"use client";
import { useIsMobile } from "@/utils/useIsMobile";
import Link from "next/link";
import React from "react";

type Props = {
  href: string;
  text: string;
  className?: string;
  ariaLable?: string;
};

export default function ArrowLinkButtonDesk({ href, text, className, ariaLable }: Props) {
  const phone = useIsMobile();
  return (
    <>
      {phone ? null : (
        <Link href={href} aria-label={ariaLable} title={text} className={`group shrink-0 flex items-center gap-2 border border-none justify-start underline text-2xs font-semibold text-primaryBlue leading-4 py-2 px-4 ml-auto transition-all duration-350 hover:scale-105 ${className}`}>
          {text}
          <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" className="transition-all duration-350 text-primaryBlue">
            <path d="M9.61984 4.1176L13.6665 8.16427L9.61984 12.2109" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M2.33029 8.16406H13.5503" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </Link>
      )}
    </>
  );
}
